<div class="flex flex-col lg:flex-row min-h-screen w-full">
  <!-- Left Side - Green Background with Content (Hidden on mobile/tablet) -->
  <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
    <div class="absolute inset-0 bg-[#016934] z-0"></div>
    <div class="absolute inset-0 z-1">
      <img
        src="/assets/images/background/bg.png"
        alt=""
        class="w-full h-full object-cover opacity-30"
      />
    </div>
    <div class="relative z-10 flex items-center h-full p-8 xl:p-12">
      <div>
        <h1 class="text-white text-4xl xl:text-6xl font-bold leading-tight">
          Connexion à l'espace Admin
        </h1>
        <div class="w-24 h-1 bg-[#F39200] my-6"></div>
        <p class="text-white text-2xl xl:text-3xl mt-6 leading-relaxed">
          Accédez à votre compte pour gérer
        </p>
        <p class="text-white text-2xl xl:text-3xl mt-1 leading-relaxed">
          efficacement vos réunions
        </p>
      </div>
    </div>
  </div>

  <!-- Right Side - Forgot Password Form (Full width on mobile/tablet, half width on desktop) -->
  <div
    class="w-full lg:w-1/2 bg-white flex flex-col justify-between min-h-screen"
  >
    <!-- Main Content -->
    <div
      class="flex flex-col items-center justify-center flex-grow px-4 py-8 sm:px-6 md:px-8 lg:px-12"
    >
      <div class="w-full max-w-md">
        <!-- Logo -->
        <div class="flex justify-center mb-6 sm:mb-8">
          <img
            src="/assets/images/logo/oneci_logo.svg"
            alt="ONECI Logo"
            class="h-12 sm:h-16 md:h-20"
          />
        </div>

        <!-- Welcome Text -->
        <div class="text-center mb-6 sm:mb-8">
          <h2
            class="text-[#016934] text-base sm:text-lg md:text-xl font-bold mb-2 leading-tight px-2"
          >
            Veuillez entrer votre adresse e-mail ci-dessous. Nous vous enverrons
            un nouveau mot de passe pour réinitialisation.
          </h2>
        </div>

        <!-- Forgot Password Form -->
        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="onSubmit()"
          class="space-y-5"
        >
          <div class="mb-5">
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Adresse e-mail
            </label>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="Entrez votre adresse e-mail"
              class="w-full px-4 py-3 sm:py-4 border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-[#F39200] text-base transition-all duration-200 hover:border-gray-400"
            />
            <div
              *ngIf="submitted && forgotPasswordForm.controls['email'].errors"
              class="text-red-500 text-xs mt-2"
            >
              <span
                *ngIf="forgotPasswordForm.controls['email'].errors['required']"
              >
                L'adresse email est requise
              </span>
              <span
                *ngIf="forgotPasswordForm.controls['email'].errors['email']"
              >
                Veuillez entrer une adresse email valide
              </span>
            </div>
          </div>

          <button
            type="submit"
            [disabled]="isLoading"
            class="w-full py-3 sm:py-4 bg-[#F39200] text-white border-none rounded-md text-base sm:text-lg font-medium cursor-pointer transition-all duration-200 hover:bg-[#E68600] hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            <!-- Loader -->
            <svg
              *ngIf="isLoading"
              class="slow-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
              ></path>
            </svg>
            <span>Valider</span>
          </button>
        </form>

        <!-- Back to Login Link -->
        <div class="text-center mt-6">
          <a
            href="#"
            class="text-[#F39200] no-underline text-sm sm:text-base hover:underline transition-all duration-200 hover:text-[#E68600]"
          >
            Retour à la connexion
          </a>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="text-center text-[#F39200] text-sm sm:text-base py-4 sm:py-6 px-4"
    >
      ONECI 2025 - Tous droits réservés
    </div>
  </div>
</div>

<!-- Modal de changement de mot de passe -->
@if (showModal) {
<div
  class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
>
  <div
    class="bg-white w-full max-w-md mx-4 sm:mx-0 rounded-lg shadow-2xl transform transition-all duration-300 scale-100"
  >
    <!-- Modal Header -->
    <div
      class="px-4 sm:px-6 py-4 bg-gray-200 rounded-t-lg flex justify-between items-center"
    >
      <h1 class="text-lg sm:text-xl font-semibold text-gray-800">
        Modification du mot de passe
      </h1>
      <button
        (click)="closeModal()"
        class="text-gray-500 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-gray-100"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>

    <form [formGroup]="changePasswordWithOtp" (ngSubmit)="confirmSave()">
      <div class="p-4 sm:p-6 space-y-4 max-h-[70vh] overflow-y-auto">
        <!-- Email Field (Disabled) -->
        <div class="form-group">
          <label
            class="block text-sm sm:text-md font-medium text-gray-700 mb-2"
          >
            Email
          </label>
          <input
            formControlName="email"
            class="w-full h-11 sm:h-12 text-sm sm:text-md border-2 border-gray-300 px-3 sm:px-4 py-2 bg-gray-100 rounded-md focus:outline-none"
            readonly
          />
        </div>

        <!-- Code OTP Field -->
        <div class="form-group">
          <label
            class="block text-sm sm:text-md font-medium text-gray-700 mb-2"
          >
            Code OTP
          </label>
          <input
            type="text"
            formControlName="codeOtp"
            maxlength="4"
            class="w-full h-11 sm:h-12 text-sm sm:text-md border-2 border-gray-300 px-3 sm:px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-[#F39200] text-center tracking-widest font-mono text-lg"
            placeholder="----"
            autocomplete="off"
          />
          @if (hasError('codeOtp', 'required')) {
          <div class="text-red-500 text-xs mt-1">Le code OTP est requis</div>
          } @if (hasError('codeOtp', 'minlength') || hasError('codeOtp',
          'maxlength')) {
          <div class="text-red-500 text-xs mt-1">
            Le code OTP doit contenir exactement 4 caractères
          </div>
          }
        </div>

        <!-- New Password Field -->
        <div class="form-group">
          <label
            class="block text-sm sm:text-md font-medium text-gray-700 mb-2"
          >
            Nouveau mot de passe
          </label>
          <div class="relative">
            <input
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              class="w-full text-sm sm:text-md h-11 sm:h-12 border-2 border-gray-300 px-3 sm:px-4 py-2 pr-12 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F39200] focus:border-[#F39200] transition-all duration-200"
              placeholder="Entrez votre nouveau mot de passe"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600 hover:text-[#F39200] transition-colors"
              (click)="togglePasswordVisibility()"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  *ngIf="hidePassword"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
                <path
                  *ngIf="hidePassword"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                ></path>
                <path
                  *ngIf="!hidePassword"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                ></path>
              </svg>
            </button>
          </div>
          @if (hasError('password', 'required')) {
          <div class="text-red-500 text-xs mt-1">
            Le nouveau mot de passe est requis
          </div>
          } @if (hasError('password', 'minlength')) {
          <div class="text-red-500 text-xs mt-1">
            Le mot de passe doit contenir au moins 8 caractères
          </div>
          }
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="px-4 sm:px-6 py-4 bg-gray-50 rounded-b-lg flex flex-col sm:flex-row justify-end gap-3 border-t"
      >
        <button
          type="button"
          (click)="closeModal()"
          class="px-6 py-2 sm:py-3 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors w-full sm:w-auto order-2 sm:order-1"
        >
          Annuler
        </button>
        <button
          type="submit"
          class="px-6 py-2 sm:py-3 bg-[#F39200] text-white rounded-md hover:bg-[#E68600] transition-colors w-full sm:w-auto order-1 sm:order-2 font-medium"
        >
          Enregistrer
        </button>
      </div>
    </form>
  </div>
</div>
}
